<template>
  <div>
    <br />
    <div class="d-flex justify-content-center">
      <span class="p-2 fs-5" :class="sale.validated ? 'text-success' : 'text-warning'">
        <span v-if="sale.validated" class="fs-5">
          <i class="bi bi-check2"></i>
        </span>
        BL Référence Nº :
        <span class="fw-bold fs-5">
          {{ $route.params.reference }}
        </span>

        <span class="fw-bold text-dark fs-5">
          {{ sale.date }}
        </span>
      </span>
    </div>
    <div class="d-flex justify-content-center align-items-center p-0">
      <div class="col-auto row">

        <div v-if="sale.reference && $userRole == 'Admin'" class="col-auto p-1">
          <button @click="moveSaleToAccounting(sale)" class="btn btn-secondary shadow">
            <i class="bi bi-plus fs-4"></i> Déplacer vers la comptabilité

          </button>
        </div>


        <div v-if="sale.reference && ($userRole == 'Admin' || $userRole == 'Commercial')
          && sale.totalPriceTTC == sale.amountUnpaid" class="col-auto p-1">
          <button @click="recalculationPrices(sale.reference)" class="btn border">
            <i class="bi bi-coin text-secondary fs-4"></i> Recalculer
          </button>
        </div>

        

        <div v-if="sale.order_reference && sale.reference && ($userRole == 'Admin' || $userRole == 'Commercial')
          && sale.totalPriceTTC == sale.amountUnpaid" class="col-auto p-1">
          <button @click="$router.push({
            name: 'orders-details', params: {
              reference: sale.order_reference
            }
          })" class="btn border">
            <i class="bi bi-coin text-secondary fs-4"></i> Commande
          </button>
        </div>

        <div v-if="!sale.validated" class="col-auto p-1">
          <button @click=" 
            $router.push({
              name: 'sales-validated',
              params: {
                reference: sale.reference,
              },
            })
            " class="btn border text-success border-success">
            <i class="bi bi-check2-square text-success fs-4"></i> Facture
          </button>
        </div>

        <div v-if="sale.reference && $userRole == 'Admin'" class="col-auto p-1">
          <button @click="
            $router.push({
              name: 'sales-edit',
              params: { reference: sale.reference },
            })
            " class="btn border">
            <i class="bi bi-pencil-square text-secondary fs-4"></i> Modifier
          </button>
        </div>

        <div v-if="sale.reference && $userRole == 'Admin'" class="col-auto p-1">
          <button @click="remove(sale.reference)" class="btn border border-danger text-danger">
            <i class="bi bi-archive-fill text-danger fs-4"></i> Supprimer
          </button>
        </div>
 
        

        <div v-if="sale.reference" class="col-auto p-1">
          <button @click="print(sale.reference)" class="btn border">
            <i class="bi bi-printer text-secondary fs-4"></i> Imprimer BL
          </button>
        </div>


        <div class="col-auto p-1">
          <button @click="refresh()" class="btn border">
            <i class="bi bi-arrow-clockwise text-secondary fs-4"></i> Actualiser
          </button>
        </div>
      </div>
    </div>
    <hr />
    
   <div class="mb-3 shadow-sm border">
  <div class="card-body">
    <p><strong>Référence :</strong> <span class="fw-bold ms-2">{{ sale.reference }}</span></p>
    <p><strong>Bon Nº :</strong> <span class="fw-bold ms-2">{{ sale.passPermit }}</span></p>
    <p><strong>Date :</strong> <span class="fw-bold ms-2">{{ sale.date }}</span></p>
    <p><strong>Client :</strong> <span class="fw-bold ms-2">{{ sale.customerFullName }}</span></p>
    <p><strong>Utilisateur :</strong> <span class="fw-bold ms-2">{{ sale.userName }}</span></p>
    <p><strong>Total TTC :</strong> <span class="fw-bold ms-2">{{ sale.totalPriceTTC }} DH</span></p>
    <p><strong>Quantité totale :</strong> <span class="fw-bold ms-2">{{ sale.totalQuantity }}</span></p>
    <p><strong>Montant payé :</strong> <span class="fw-bold ms-2">{{ sale.amountPaid }} DH</span></p>
    <p><strong>Montant impayé :</strong> <span class="fw-bold ms-2">{{ sale.amountUnpaid }} DH</span></p>
    <p><strong>Remarques :</strong> <span class="fw-bold ms-2">{{ sale.remark }}</span></p>
    <p>
      <strong>Validée :</strong>
      <span :class="[sale.validated ? 'text-success' : 'text-danger', 'fw-bold', 'ms-2']">
        {{ sale.validated ? 'Oui' : 'Non' }}
      </span>
    </p>
  </div>
</div>


    <!-- Articles vendus -->
    <div class="mb-4">
      <div class="card-header ">Articles </div>
      <div class="card-body p-0">
        <table class="table table-striped table-hover">
          <thead class="table-light">
            <tr>
              <th>Article</th>
              <th>Quantité</th>
              <th>Prix </th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in sale.sale_items" :key="index">
              <td>{{ item.itemName }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.priceTTC }}</td>
              <td>{{ item.totalPriceTTC }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Paiements -->
    <div class="mb-4">
      <div class="card-header">Paiements</div>
      <div class="card-body p-0">
        <table class="table table-striped table-hover">
          <thead class="table-light">
            <tr>
              <th>Montant</th>
              <th>Méthode</th>
              <th>Date</th>
              <th>Utilisateur</th>
              <th>Référence</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(payment, index) in sale.payments" :key="index">
              <td>{{ payment.amount }}</td>
              <td>{{ payment.paymentMethod }}</td>
              <td>{{ payment.date }}</td>
              <td>{{ payment.user }}</td>
              <td>{{ payment.reference }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Chèques -->
    <div class="">
      <div class="card-header ">Chèques associés</div>
      <div class="card-body p-0">
        <table class="table table-striped table-hover">
          <thead class="table-light">
            <tr>
              <th>Référence</th>
              <th>Montant</th>
              
              <th>Banque</th>
              <th>Date</th>
              <th>Échéance</th>
              <th>Numéro</th>
              <th>Validé</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(check, index) in sale.checks" :key="index">
              <td>{{ check.reference }}</td>
              <td>{{ check.amount }}</td>
             
              <td>{{ check.bank }}</td>
              <td>{{ check.date }}</td>
              <td>{{ check.deadline }}</td>
              <td>{{ check.checkNumber }}</td>
              <td :class="check.validated === 'Validé' ? 'text-success' : 'text-danger'">
                {{ check.validated }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  data() {
    return {};
  },

  mounted() {
    this.$store.dispatch("sale/show", this.$route.params.reference);
  },
  computed: {
    ...mapGetters("sale", {
      sale: "getSale",
    }),
    ...mapGetters("auth", {
      userRole: "getUserRole",
    }),
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("sale/show", this.$route.params.reference);
    },
    async recalculationPrices(reference) {
      await this.$store.dispatch("sale/recalculationPrices", reference);
      await this.refresh();
    },

    async addManutention(reference) {
      await this.$store.dispatch("sale/addManutention", reference);
      await this.refresh();
    },

    async print(reference) {
      this.$store.dispatch("sale/print", reference);
    },
    async printQuotation(reference) {
      this.$store.dispatch("sale/printQuotation", reference);
    },
    async printInvoice(reference) {
      this.$store.dispatch("sale/printInvoice", reference);
    },
    async remove(reference) {
      this.$store.dispatch("sale/destroy", reference);
    },
    async createInvoice(reference) {

      await this.$store.dispatch("invoice/store", {
        sale_reference: reference
      });
    },
    
    async moveSaleToAccounting(data) {
      await this.$store.dispatch('sale/moveToAccounting', data);
    
  }
  },
  filters: {
    toFixedWithSpace: (value) => {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
  },
};
</script>
